import React from 'react'
import styled from 'styled-components'
import svg from '@/assets/loading/grid.svg'
import { FadeIn } from '@/lib/css-lib'

const Container = styled.div`
    width: 100%;
    height: 100%;
    padding: 70px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const Inner = styled.div`
    width: 40px;
    height: 40px;
    transform: translate(-50%, -50%);
`;

/**
 * ローディング中のアニメーション
 */
const Loading: React.FC<{}> = () => {
    return (
        <Container>
            <Inner>
                <FadeIn>
                    <img src={svg} alt="loading" />
                </FadeIn>
            </Inner>
        </Container>
    )
}

export default Loading
